import { render, staticRenderFns } from "./recruitmentMsg.vue?vue&type=template&id=9c47e512&scoped=true"
import script from "./recruitmentMsg.vue?vue&type=script&lang=js"
export * from "./recruitmentMsg.vue?vue&type=script&lang=js"
import style0 from "./recruitmentMsg.vue?vue&type=style&index=0&id=9c47e512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c47e512",
  null
  
)

export default component.exports